import React from "react";
import { Navigate } from "react-router-dom";

/**
 * Pricing — until pricing gets its own long-form page, redirect
 * /pricing → /#pricing so direct-landing visitors (audit D2.4) hit
 * the real pricing content instead of an empty SPA shell.
 */
export default function Pricing() {
  return <Navigate to="/#pricing" replace />;
}
